import { styled } from '@mui/material/styles';

export const ResponseExcerpt = styled('span')({
  display: 'block',
  fontFamily: 'monospace',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});
